import { _js } from '@ifixit/utils/localize';
import { Component } from 'react';

class ConfirmDelete extends Component {
   render() {
      return (
         <div className="js-delete-modal-box delete-modal-box">
            <form id="commentDeleteForm" method="post" action="/Answers/View/Delete">
               <input
                  type="hidden"
                  name="doctype"
                  className="js-delete-doctype"
                  value={this.props.doctype}
               />
               <input
                  type="hidden"
                  name="docid"
                  className="js-delete-docid"
                  value={this.props.docid}
               />

               <p className="js-delete-name">
                  {/* Translators: %1 -> delete item type */}
                  {_js('Are you sure you want to delete this %1?', this.props.doctype)}
               </p>
               <div className="buttons">
                  <button type="button" className="button button-link js-cancel-button">
                     {_js('Cancel')}
                  </button>
                  <input
                     type="submit"
                     id="deleteDoctype"
                     className="button button-action-solid"
                     value={_js('Delete it!')}
                  />
               </div>
            </form>
         </div>
      );
   }

   componentDidMount() {
      $$('.js-delete-modal-box .js-cancel-button').addEvent('click', () => {
         void import('Shared/modal').then(({ Modal }) => {
            Modal.cancel();
         });
      });
   }
}

export default ConfirmDelete;
